import React from 'react'
import './HeaderActions.css'
import { ChildrenProps } from '../../modules/types'

function HeaderActions(props: ChildrenProps) {
  return (
    <div id="header-actions" className={"flex-row"}>
      {props.children}
    </div>
  )
}

export default HeaderActions
